<template>
  <div class="dropdownDoc">
    <documentation-container :title="title">
      <template slot="content">
        <div class="dropdown-layout">
          <div class="dropdown-spacing">
            <h3 class="dropdown-title">Dropdown Search</h3>
            <dropdown-search  @selected="selectedSearch" :list="search" labelButton="Locations" :selected-value="selectedSearchValue"/>
          </div>
          <div>
            <h3 class="dropdown-title">Dropdown Checkbox</h3>
            <dropdown-checkbox @selected="selected" :list="checkbox" labelButton="Brands" />
          </div>
          <div>
            <h3 class="dropdown-title">Dropdown List</h3>
            <dropdown-list @selected="selected" :list="list" labelButton="Package" />
          </div>
          <div>
            <h3 class="dropdown-title">Dropdown Status</h3>
            <dropdown-status @selected="selected" :list="listStatus" labelButton="Status" />
          </div>
          <div>
            <h3 class="dropdown-title">Unlabel Dropdown</h3>
            <dropdown-unlabel @selected="selected" :list="menuList" labelButton=''/>
          </div>
          <div>
            <h3 class="dropdown-title">Dropdown 2 Level</h3>
            <dropdown-2-level @selected="selected"  :lists="bulkAction" labelButton="Bulk Action"/>
          </div>
        </div>
        <div class="dropdown-layout">
          <div>
            <h3 class="dropdown-title">Dropdown Filter</h3>
            <dropdown-filter-date @selected="selectedSort" :list="dateList" labelButton='Date Filter' :startDate="dateFormate.start" :endDate="dateFormate.end" />
          </div>
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownStatus from '@/components/Dropdown/StatusDropdown'
import DropdownUnlabel from '@/components/Dropdown/UnlabelDropdown'
import Dropdown2Level from '@/components/Dropdown/Dropdown2Level'
import DocumentationContainer from '@/components/DocumentationContainer'
import DropdownDateFilter from '@/components/Dropdown/FilterDateDropdown'
import { formatShortDate, dateFormat } from '@/lib/util'
import moment from 'moment'

export default {
  name: 'adx-dropdown-doc',
  components: {
    DropdownSearch,
    DropdownCheckbox,
    DropdownList,
    DropdownStatus,
    DropdownUnlabel,
    'dropdown-filter-date':DropdownDateFilter,
    'dropdown-2-level': Dropdown2Level,
    'documentation-container': DocumentationContainer,

  },
  data() {
    return {
      title: 'Dropdown',
      search: [
        {
          'id': 0,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 0,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 1,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 2,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 3,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 4,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 5,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 6,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 7,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 8,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 9,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            }
          ]
        },
        {
          'id': 1,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 10,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 11,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 12,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 13,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 14,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 15,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 16,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 17,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 18,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 19,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            }
          ]
        },
        {
          'id': 2,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 20,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 21,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 22,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 23,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 24,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 25,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 26,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 27,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 28,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 29,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            }
          ]
        }
      ],
      checkbox: [
        {
          'id': 0,
          'label': 'Bebek Kaleyo',
          'value': 'BK',
        },
        {
          'id': 1,
          'label': 'Laus Kopi',
          'value': 'LK'
        },
        {
          'id': 2,
          'label': 'Upnormal',
          'value': 'UP'
        },
        {
          'id': 3,
          'label': 'Abuba',
          'value': 'AB'
        },
        {
          'id': 4,
          'label': 'Concordia',
          'value': 'CO'
        }
      ],
      list: [
        {
          'id': 0,
          'label': 'Gaul',
          'value': 'GA',
        },
        {
          'id': 1,
          'label': 'Jadul',
          'value': 'JA'
        },
        {
          'id': 2,
          'label': 'Konser',
          'value': 'KO'
        },
        {
          'id': 3,
          'label': 'Nobar',
          'value': 'NO'
        },
        {
          'id': 4,
          'label': 'Seminar',
          'value': 'SE'
        }
      ],
      listStatus:[
        {
          'id': 0,
          'label': 'Lead',
          'value': 'lead'
        },
        {
          'id': 1,
          'label': 'Upcoming',
          'value': 'upcoming'
        },
        {
          'id': 2,
          'label': 'Printapproval',
          'value': 'printapproval'
        },
        {
          'id': 3,
          'label': 'Expired',
          'value': 'expired'
        },
        {
          'id': 4,
          'label': 'Wrapping',
          'value': 'wrapping'
        },
        {
          'id': 5,
          'label': 'Printing',
          'value': 'printing'
        },
        {
          'id': 6,
          'label': 'Designing',
          'value': 'designing'
        }
      ],
      menuList: [
        {
          'id': 0,
          'label': 'Print',
          'value': 'print',
        },
        {
          'id': 1,
          'label': 'Delete Order',
          'value': 'deleteorder',
        },
        {
          'id': 2,
          'label': 'Set as Dormant Order',
          'value': 'dormantorder',
        },
      ],
      dateList: [
        {
          'id': 0,
          'label': 'Today',
          'value': 'today',
        },
        {
          'id': 1,
          'label': 'Last 7 Days',
          'value': 'last-7-days',
        },
        {
          'id': 2,
          'label': 'Last 30 Days',
          'value': 'last-30-days',
        },
        {
          'id': 3,
          'label': 'All Time',
          'value': 'alltime',
        },
        {
          'id': 4,
          'label': 'Custom Date',
          'value': 'customdate',
        },
      ],
      bulkAction: [ 
        {
          "id": 0,
          "name": "Change Progress",
          "value": "S",
          "items": [
            {
              'label': 'Designing',
              'value': 'designing'
            },
            {
              'label': 'Verifying',
              'value': 'verifying'
            },
            {
              'label': 'Validating',
              'value': 'validating'
            },
            {
              'label': 'Wrapping',
              'value': 'wrapping'
            },
          ]
        },
        {
          "id": 1,
          "name": "View Detail",
          "value": "AP",
        },
      ],
      selectedSearchValue: '',
      selectedDate: '',
      dateFormate:{
        start : '2019-05-08',
        end : '2019-05-10'
      },
    }
  },
  methods: {
    selected(item){
      console.log(item)
    },
    selectedSearch(item){
      this.selectedSearchValue = item.id.toString()
    },
    selectedSort(item){
      this.selectedDate = item.value
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
